const isNil = (value:any) => value == null;

export function getItem(item: string, defaultValue:string|null = null): string | null {
  try {
    const value = window.localStorage.getItem(item);

    if (isNil(value) && !isNil(defaultValue)) {
      return defaultValue;
    }

    return value;
  } catch (e) {
    return null;
  }
}

export function getParsedItem<T>(item: string): T | null {
  try {
    return JSON.parse(getItem(item) || 'null');
  } catch (e) {
    return null;
  }
}

export const setItem = (key: string, item: string) => {
  try {
    window.localStorage.setItem(key, item);
  } catch (e) {
    // The error will be ignored
  }
};

export const removeItem = (key: string) => {
  try {
    window.localStorage.removeItem(key);
  } catch (e) {
    // The error will be ignored
  }
};
